import {from, switchMap, throwError} from 'rxjs';
import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { AuthenticationService } from '../service/authentication.service';
import {isLightRoute} from "@adlatus-gui/shared";

function cloneRequestAndAssignAuthorization(req: HttpRequest<unknown>, token: string) {
  return req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });
}

function cloneRequestAndAssignLightToken(req: HttpRequest<unknown>, token: string) {
  return req.clone({
    setHeaders: {
      'X-Light-Access-Token': token
    }
  });
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authenticationService = inject(AuthenticationService);

  if (isLightRoute()) {
    const lightToken = getLightToken()!;
    const authReq = cloneRequestAndAssignLightToken(req, lightToken);
    return next(authReq);
  }

  if (authenticationService.isTokenExpired()) {
    return from(authenticationService.updateToken())
      .pipe(
        switchMap(() => from(authenticationService.getAccessToken())), // Get the new token
        switchMap(token => {
          const authReq = cloneRequestAndAssignAuthorization(req, token);
          return next(authReq);
        })
      );
  } else {
    return from(authenticationService.getAccessToken())
      .pipe(
        switchMap(token => {
          const authReq = cloneRequestAndAssignAuthorization(req, token);
          return next(authReq);
        })
      );
  }
};

function getLightToken(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('t');
}
